import { CoursesHero } from '@/components/courses/CoursesHero'
import { CoursesGallery } from '@/components/courses/CoursesGallery'
import { CoursesContent } from '@/components/courses/CoursesContent'
import { CoursesTestimonial } from '@/components/courses/CoursesTestimonial'

export const CoursesPage = () => (
  <>
    <CoursesHero />
    <CoursesGallery />
    <CoursesContent />
    <CoursesTestimonial />
  </>
)
